import React, { useState, useEffect } from 'react';
import './AnalogClock.css'; // CSS file for clock styles

const AnalogClock = () => {
  const [time, setTime] = useState({ hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    // Function to update the clock hands every second
    const updateClock = () => {
      const currentTime = new Date();
      const hours = currentTime.getHours();
      const minutes = currentTime.getMinutes();
      const seconds = currentTime.getSeconds();

      setTime({
        hours: hours % 12, // 12-hour format
        minutes,
        seconds,
      });
    };

    // Update the clock immediately on mount
    updateClock();

    // Set an interval to update the clock every second
    const intervalId = setInterval(updateClock, 1000);

    // Cleanup the interval when the component is unmounted
    return () => clearInterval(intervalId);
  }, []);

  // Clock hands rotation calculation
  const hoursDeg = (time.hours + time.minutes / 60) * 30; // 360 / 12 = 30 degrees per hour
  const minutesDeg = (time.minutes + time.seconds / 60) * 6; // 360 / 60 = 6 degrees per minute
  const secondsDeg = time.seconds * 6; // 360 / 60 = 6 degrees per second

  return (
    <div className="clock-container">
      <div className="clock">
        {/* Hour, Minute and Second Hands */}
        <div
          className="clock-hour-hand"
          style={{
            transform: `rotate(${hoursDeg}deg)`,
          }}
        />
        <div
          className="clock-minute-hand"
          style={{
            transform: `rotate(${minutesDeg}deg)`,
          }}
        />
        <div
          className="clock-second-hand"
          style={{
            transform: `rotate(${secondsDeg}deg)`,
          }}
        />
        
        {/* Clock Numbers (1 to 12) */}
        {[...Array(12)].map((_, index) => {
          const angle = (index * 30) - 90; // 360 / 12 = 30 degrees for each number, -90 to start at the top
          const radian = (angle * Math.PI) / 180;
          const x = 50 + 40 * Math.cos(radian); // 40 is the radius for number positioning
          const y = 50 + 40 * Math.sin(radian); // 50 is the center point of the clock
          return (
            <div
              key={index}
              className="clock-number"
              style={{
                position: 'absolute',
                top: `${y}%`,
                left: `${x}%`,
                transform: 'translate(-50%, -50%)',
                fontSize: '10px',
                fontWeight: 'bold',
                color: '#333',
              }}
            >
              {index === 0 ? 12 : index} {/* Ensure 12 is displayed at the top */}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AnalogClock;
